// extracted by mini-css-extract-plugin
export var emptyState = "_6n-d";
export var statCard = "_6n-c";
export var table = "_6n-0";
export var tableCell = "_6n-4";
export var tableCellClickable = "_6n-5 _6n-4";
export var tableCellDefault = "_6n-6 _6n-4";
export var tableCellEmpty = "_6n-8";
export var tableCellWithValue = "_6n-7";
export var tableContainer = "_6n-e";
export var tableHeaderWeight = "_6n-1";
export var tableHeaderZone = "_6n-2";
export var tableRowHeader = "_6n-3";
export var viewModeButton = "_6n-9";
export var viewModeButtonActive = "_6n-a _6n-9";
export var viewModeButtonInactive = "_6n-b _6n-9";